import { useTranslation } from 'react-i18next';
import { Construction } from 'lucide-react';

interface PlaceholderPageProps {
  titleKey: string;
  modKey: string;
}

/**
 * Stand-in shell for module pages until each MOD-N issue ships its own UI.
 * Keeps the navigation reachable and proves auth/RLS routing works end-to-end.
 */
export function PlaceholderPage({ titleKey, modKey }: PlaceholderPageProps) {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-3xl py-12">
      <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">{t(titleKey)}</h1>
      <div className="mt-8 rounded-lg border border-dashed border-gray-300 bg-card-light p-8 text-center dark:border-gray-700 dark:bg-card-dark">
        <Construction className="mx-auto h-10 w-10 text-gray-400 dark:text-gray-500" />
        <h2 className="mt-3 text-base font-medium text-gray-900 dark:text-white">
          {t('placeholder.module_pending')}
        </h2>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {t('placeholder.module_pending_long')}
        </p>
        <p className="mt-3 font-mono text-xs text-gray-400 dark:text-gray-500">{modKey}</p>
      </div>
    </div>
  );
}
